
class DesktopScrollGallery {
  constructor(container) {
    this.container = container;
    this.images = container.querySelectorAll('.desktop-scroll-gallery-image');
    this.thumbnails = container.querySelectorAll('.desktop-scroll-gallery-thumbnail-item');
    this.thumbnailsContainer = container.querySelector('.desktop-scroll-gallery-thumbnails-container');
    
    this.currentImageIndex = 0;
    this.isScrolling = false;
    this.isUserScrolling = false;
    this.scrollTimeout = null;
    this.galleryStartScroll = null;
    
    this.init();
  }

  init() {
    if (this.images.length === 0 || this.thumbnails.length === 0) return;
    
    if (window.innerWidth < 990) return;
    
    this.setupEventListeners();
    this.updateImageDisplay();
    this.setupIntersectionObserver();
    this.setupKeyboardNavigation();
  }

  setupEventListeners() {
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.jumpToImage(index);
      });
    });

    // Handle manual scrolling of thumbnails container
    if (this.thumbnailsContainer) {
      this.thumbnailsContainer.addEventListener('scroll', this.handleThumbnailScroll.bind(this), { passive: true });
    }

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isInViewport = true;
        } else {
          this.isInViewport = false;
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(this.container);
  }

  setupKeyboardNavigation() {
    document.addEventListener('keydown', (e) => {
      if (!this.isInViewport) return;
      
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        if (this.currentImageIndex < this.images.length - 1) {
          this.jumpToImage(this.currentImageIndex + 1);
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        if (this.currentImageIndex > 0) {
          this.jumpToImage(this.currentImageIndex - 1);
        }
      }
    });
  }

  handleScroll() {
    if (this.isScrolling || !this.isInViewport) return;
    
    this.isScrolling = true;
    this.isUserScrolling = true;
    
    requestAnimationFrame(() => {
      this.updateScrollPosition();
      this.isScrolling = false;
      
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isUserScrolling = false;
      }, 150);
    });
  }

  updateScrollPosition() {
  const scrollTop = window.pageYOffset;
  const galleryRect = this.container.getBoundingClientRect();

  if (this.galleryStartScroll === null && galleryRect.top <= 90) {
    this.galleryStartScroll = scrollTop;
  }

  if (galleryRect.top <= 90 && galleryRect.bottom > 20 && this.galleryStartScroll !== null) {
    const thumbnailHeight = 109; // 100px height + 9px margin-bottom
    const totalScrollableHeight = this.thumbnails.length * thumbnailHeight;
    const relativeScroll = scrollTop - this.galleryStartScroll;

    const step = thumbnailHeight * 2;
    const newImageIndex = Math.min(Math.floor(relativeScroll / step), this.images.length - 1);

    if (newImageIndex !== this.currentImageIndex && newImageIndex >= 0) {
      this.currentImageIndex = newImageIndex;
      this.updateImageDisplay();
    }
  }

  if (galleryRect.top > 90) {
    this.galleryStartScroll = null;
  }
}


  updateImageDisplay() {
    this.images.forEach((img, index) => {
      img.classList.toggle('active', index === this.currentImageIndex);
    });
    
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.classList.toggle('active', index === this.currentImageIndex);
    });

    // Scroll thumbnails container to center the active thumbnail
    // this.scrollToActiveThumbnail();
  }

  scrollToActiveThumbnail() {
    if (!this.thumbnailsContainer || this.thumbnails.length === 0) return;

    const activeThumbnail = this.thumbnails[this.currentImageIndex];
    if (!activeThumbnail) return;

    const containerHeight = this.thumbnailsContainer.clientHeight;
    const thumbnailHeight = 109; // 100px height + 9px margin-bottom
    const activeThumbnailTop = activeThumbnail.offsetTop;
    const activeThumbnailCenter = activeThumbnailTop + (thumbnailHeight / 2);
    const containerCenter = containerHeight / 2;
    
    const targetScrollTop = activeThumbnailCenter - containerCenter;
    
    this.thumbnailsContainer.scrollTo({
      top: Math.max(0, targetScrollTop),
      behavior: 'smooth'
    });
  }

  handleThumbnailScroll() {
    // Prevent interference with main scroll logic when user manually scrolls thumbnails
    // This is just to prevent conflicts, the main scroll logic will still work
  }


  jumpToImage(index) {
    if (index < 0 || index >= this.images.length) return;
    
    // Just update the current image index and display
    // Don't scroll the main page when clicking thumbnails
    this.currentImageIndex = index;
    this.updateImageDisplay();
  }


  handleResize() {
    if (window.innerWidth >= 990 && !this.isInitialized) {
      this.isInitialized = true;
      this.init();
    } else if (window.innerWidth < 990 && this.isInitialized) {
      this.isInitialized = false;
      this.cleanup();
    }
  }

  cleanup() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.handleResize.bind(this));
    
    if (this.thumbnailsContainer) {
      this.thumbnailsContainer.removeEventListener('scroll', this.handleThumbnailScroll.bind(this));
    }
    
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('.desktop-scroll-gallery');
  
  galleries.forEach(gallery => {
    new DesktopScrollGallery(gallery);
  });
});

window.addEventListener('load', function() {
  const galleries = document.querySelectorAll('.desktop-scroll-gallery:not([data-initialized])');
  
  galleries.forEach(gallery => {
    gallery.setAttribute('data-initialized', 'true');
    new DesktopScrollGallery(gallery);
  });
});

window.DesktopScrollGallery = DesktopScrollGallery;